<template lang="pug">
    div(class="subtitle-text primary--text") Tipe Transaksi
        v-radio-group(dense v-model="type" :row="row" @change="onSelect" :readonly="readonly")
            v-radio(label="SP2D" value="SP2D" color="primary" )
            v-radio(label="SPJ" value="SPJ" color="primary")
</template>
<script>
export default {
    name: "FRadioKasdaType",
    props: ["value","readonly","row"],
    data() {
        return {
            type: null
        };
    },
    mounted() {
        this.doInitModel(this.value);
    },
    watch: {
        value(val) {
            this.doInitModel(val);
        }
    },
    methods: {
        doInitModel(values) {
            this.type = values ? "" + values : "1";
            this.onSelect();
        },
        onSelect() {
            this.$emit("input", this.type);
            this.$emit("select", this.type);
        }
    }
};
</script>